module.exports = __webpack_public_path__ + "static/car0-2d1e40dbfeb9758484db5b6caee425dd.png";